import React, { useState, useEffect } from 'react';
import {Alert} from 'reactstrap';


export const AlertMensaje = (props) => {
	const Mensajes = [
		" Enviando ...",
		" Su CV ha sido enviado con exito",
		" Fallo el registro de CV, intentelo nuevamente más tarde."
	];
	const ClassNames = [
		"alert-info",
		"alert-success",
		"alert-danger",
	];
	return props.Estado > 0 && (props.Estado - 1) < Mensajes.length && (
		<Alert className={ClassNames[props.Estado - 1]}>
			{props.Estado === 1 && (<i className="fa fa-spinner fa-spin" aria-hidden="true"></i>)}
			{props.Estado === 2 && (<i className="fa fa-check" aria-hidden="true"></i>)}
			{props.Estado === 3 && (<i className="fa fa-times" aria-hidden="true"></i>)}
			{Mensajes[props.Estado - 1]}
		</Alert>
	);
}

export const InputComponent = (props) =>
    <div className="form-group">
        {props.component}
        {
            props.error && props.error.length > 0 &&
            <div class="invalid-feedback">
                {props.error}
            </div>
        }
    </div>

export const InputLabeled = (props) =>{
    
    return(
        <div className="form-group">
            <input
                type={props.type ? props.type : "text"} 
                placeholder={props.placeholder}
                name={props.name}
                className={props.className + (props.error ? " is-invalid" : "")}
                onChange={props.onChange}
            />
            {
                props.error &&
                <div class="invalid-feedback">
                    {props.error}
                </div>
            }
        </div>
    )
}